import { apiSlice } from './baseApi';

export const orderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getOrder: builder.query({
      query: (id) => ({ url: `/orders/${id}`, method: 'GET' }),
      transformResponse: (response) => response?.order,
      providesTags: ['Orders'],
    }),
    getOrders: builder.query({
      query: ({ companyId, page, tableFilterOutcomingData, limit = 10, customerId }) => ({
        url: '/order/get-all-orders',
        method: 'POST',
        body: {
          company_id: companyId,
          page,
          tableFilterOutcomingData,
          limit,
          ...(customerId != null && customerId !== '' && { customer_id: customerId }),
        },
      }),
      transformResponse: (response) => ({
        orders: response?.orders ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['Orders'],
    }),
    getUserOrders: builder.query({
      query: ({ companyId, userId, page, tableFilterOutcomingData, limit = 10 }) => ({
        url: '/order/get-all-users-orders',
        method: 'POST',
        body: {
          company_id: companyId,
          user_id: userId,
          page,
          tableFilterOutcomingData,
          limit,
        },
      }),
      transformResponse: (response) => ({
        orders: response?.orders ?? [],
        totalPages: response?.totalPages ?? 1,
      }),
      providesTags: ['Orders'],
    }),
    changeOrderPayStatus: builder.mutation({
      query: (body) => ({
        url: '/order/change-order-pay-status',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders'],
    }),
    deleteOrder: builder.mutation({
      query: (body) => ({
        url: '/order/delete-order',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'Invoices', 'ServiceItems', 'AccountCodeAmounts'],
    }),
    changeOrderDate: builder.mutation({
      query: (body) => ({
        url: '/order/change-date',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders'],
    }),
    addOrder: builder.mutation({
      query: (body) => ({
        url: '/order/add-new-order',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'Customers', 'ServiceItems', 'AccountCodeAmounts'],
    }),
    addServiceToOrder: builder.mutation({
      query: (body) => ({
        url: '/order/add-new-service',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Orders', 'ServiceItems', 'AccountCodeAmounts'],
    }),
  }),
});
